import { Link } from "react-router-dom"
import { ChevronRight } from "lucide-react"

const CRUMB_TO = {
  Procurement: "/procurement/budget",
  Budget: "/procurement/budget",
  "Budget control": "/procurement/budget",
  "My orders": "/procurement/my-orders",
  "My Orders": "/procurement/my-orders",
  Orders: "/procurement/orders",
  Purchases: "/procurement/purchases",
  Items: "/procurement/items",
  "Book Inventory": "/procurement/book-inventory",
  Suppliers: "/procurement/suppliers",
  Reports: "/procurement/report",
  Payment: "/procurement/payment-requests",
  "Payment requests": "/procurement/payment-requests",
  "To pay": "/procurement/to-pay",
}

export const PageHeader = ({ breadcrumb = [], title, subtitle, actions }) => (
  <header className="pc-header">
    <div style={{ minWidth: 0 }}>
      {breadcrumb.length > 0 && (
        <nav className="pc-breadcrumb" aria-label="Breadcrumb">
          {breadcrumb.map((b, i) => {
            const last = i === breadcrumb.length - 1
            const label = typeof b === "string" ? b : b.label
            const to = typeof b === "string" ? CRUMB_TO[b] : b.to
            return (
              <span key={`${label}-${i}`} style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                {i > 0 && <ChevronRight aria-hidden />}
                {!last && to ? <Link to={to}>{label}</Link> : <span>{label}</span>}
              </span>
            )
          })}
        </nav>
      )}
      {title && <h1 className="pc-h1">{title}</h1>}
      {subtitle && <p className="pc-sub">{subtitle}</p>}
    </div>
    {actions && <div className="pc-header-actions">{actions}</div>}
  </header>
)

export default PageHeader
